module.exports = __webpack_public_path__ + "static/media/view-mode-icon.41c3d4a2.svg";